import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {CSSTransition} from "react-transition-group";
import * as _ from "lodash";

import InputElement from "../../../components/components/InputElement";
import {listaAttivita, listaIndividui} from "../../../fanctionUtility";

import {loadingOverlayActions, pianificazioneCalendarioActions} from "../../../actions";
import {dayJS} from "../../../applicationConf";

const GenericFilter = (props) => {

    const {id: idCorso} = useParams();

    const attivita = useSelector(state => state.tipoAttivita.attivita);
    const docenti = useSelector(state => state.docenti.docenti);
    const individui = useSelector(state => state.individui.individui);
    const label_month = useSelector(state => state.pianificazioneCalendario.label_month);
    const corso = useSelector(state => state.corso.corso);

    const dispatch = useDispatch();

    const resetPlanningCalendar = React.useCallback(() => dispatch(pianificazioneCalendarioActions.resetPianificazioneCalendario()), [dispatch]);
    const showLoading = React.useCallback(() => dispatch(loadingOverlayActions.showLoadingOverlay()), [dispatch]);
    const getPlanningCalendarCrew = React.useCallback((requestFiltri = {}) => dispatch(pianificazioneCalendarioActions.getPianificazioniCalendarioCrea(requestFiltri)), [dispatch]);
    const initializationCalendar = React.useCallback((idCorso) => dispatch(pianificazioneCalendarioActions.initializationCalendario(idCorso)), [dispatch]);

    const [openBody, setOpenBody] = React.useState(false);
    const [searchFields, setSearchFields] = React.useState({
        idTipoAttivita: {
            elementType: 'select',
            elementConfig: {
                options: listaAttivita(attivita)
            },
            value: '',
            label: 'Tipi Attività',
            cssClass: 'col-md-5 col-12 m-2',
        },
        allievi: {
            elementType: 'select',
            elementConfig: {
                options: listaIndividui(_.sortBy(individui, ['cognome']))
            },
            value: '',
            label: 'Allievo:',
            cssClass: 'col-md-5 col-12 m-2'
        },
        idDocente: {
            elementType: 'select',
            elementConfig: {
                options: listaIndividui(_.sortBy(docenti, ['cognome']))
            },
            value: '',
            label: 'Docente:',
            cssClass: 'col-md-5 col-12 m-2'
        },
        idCoDocente: {
            elementType: 'select',
            elementConfig: {
                options: listaIndividui(_.sortBy(docenti, ['cognome']))
            },
            value: '',
            label: 'Codocente:',
            cssClass: 'col-md-5 col-12 m-2'
        }
    });

    const requestCalendarCrew = React.useCallback(() => {
        const requestFilter = {};

        Object.keys(searchFields)
            .filter(key => searchFields[key].value !== '')
            .forEach(key =>
                key === 'allievi' ? requestFilter[key] = Array.of(searchFields[key].value) : requestFilter[key] = searchFields[key].value
            );

        return requestFilter;
    }, [searchFields]);


    React.useEffect(() => {
        initializationCalendar(idCorso);
    }, [initializationCalendar, idCorso])


    const initialized = React.useRef(false);
    React.useEffect(() => {
        if (!label_month) {
            return;
        }
        initialized.current = true;
        showLoading();
        resetPlanningCalendar();
        const filters = requestCalendarCrew();
        const urlDate = window.location.href.split('?')[1]?.replace('date=', '');
        if (urlDate) {
            filters.date = urlDate;
        } else {
            // Usa label_month che contiene il mese da visualizzare
            filters.date = dayJS(label_month).format('YYYY-MM');
        }
        getPlanningCalendarCrew(filters);
    }, [resetPlanningCalendar, getPlanningCalendarCrew, requestCalendarCrew, showLoading, label_month]);
    

    const clear = React.useCallback(() => {
        const copySearchFields = _.cloneDeep(searchFields);

        Object.keys(copySearchFields).forEach(key => copySearchFields[key].value = '');

        setSearchFields(copySearchFields);
    }, [searchFields]);


    return (
        <CSSTransition classNames='filter'
                       in={props.showFilter}
                       mountOnEnter
                       unmountOnExit
                       appear
                       timeout={1200}>

            <div className='card shadow mt-2 mb-4'>
                <div className="card-body">
                    <div className='row'>
                        <div className='col-4 m-auto text-center'>
                            <div className="d-inline-block" style={{cursor: 'pointer'}}
                                 onClick={() => setOpenBody(prevState => !prevState)}>
                                <i className={`fa ${openBody ? 'fa-caret-down' : 'fa-caret-right'} fa-lg mr-2`}/>
                                Filtri
                            </div>
                        </div>
                    </div>

                    <CSSTransition classNames='body__filter'
                                   in={openBody}
                                   mountOnEnter
                                   unmountOnExit
                                   timeout={800}>

                        <div>
                            <div className="d-inline-flex flex-wrap align-items-center justify-content-center w-100">

                                {Object.keys(searchFields).map(key => (
                                    <InputElement key={key}
                                                  label={searchFields[key].label}
                                                  elementType={searchFields[key].elementType}
                                                  elementConfig={searchFields[key].elementConfig}
                                                  value={searchFields[key].value}
                                                  changedValue={(event) => setSearchFields(prevState => ({
                                                          ...prevState,
                                                          [key]: Object.assign(searchFields[key], {value: event.target.value})
                                                      }))}
                                                  classes={searchFields[key].cssClass}/>

                                ))}

                            </div>
                            <div className="row">
                                <div className="col-4 mx-auto mt-5 d-flex align-items-center justify-content-around">
                                    {/*<button
                                        className="btn btn-primary shadow d-inline-flex align-items-center justify-content-around w-25"
                                        onClick={() => getPlanningCalendarCrew(requestCalendarCrew())}
                                        type="button">
                                        <i className="fa fa-search"/>
                                        Filtra
                                    </button>*/}
                                    <button
                                        className="btn btn-warning shadow d-inline-flex align-items-center justify-content-center w-25"
                                        onClick={() => clear()}
                                        type="button">
                                        <i className="fa fa-repeat mr-2"/>
                                        Pulisci
                                    </button>
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </div>
        </CSSTransition>
    )
};

export default GenericFilter;
